"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@mui/system");
var MuiCssBaseline_1 = require("./components/MuiCssBaseline");
var colors_1 = require("./colors");
var MuiAlert_1 = require("./components/MuiAlert");
var MuiAutocomplete_1 = require("./components/MuiAutocomplete");
var MuiAvatar_1 = require("./components/MuiAvatar");
var MuiBadge_1 = require("./components/MuiBadge");
var MuiButton_1 = require("./components/MuiButton");
var MuiBreadcrumbs_1 = require("./components/MuiBreadcrumbs");
var MuiCard_1 = require("./components/MuiCard");
var MuiCheckbox_1 = require("./components/MuiCheckbox");
var MuiChip_1 = require("./components/MuiChip");
var MuiDialog_1 = require("./components/MuiDialog");
var MuiDrawer_1 = require("./components/MuiDrawer");
var MuiFab_1 = require("./components/MuiFab");
var MuiFormLabel_1 = require("./components/MuiFormLabel");
var MuiGrid_1 = require("./components/MuiGrid");
var MuiIconButton_1 = require("./components/MuiIconButton");
var MuiInput_1 = require("./components/MuiInput");
var MuiLinearProgress_1 = require("./components/MuiLinearProgress");
var MuiLink_1 = require("./components/MuiLink");
var MuiList_1 = require("./components/MuiList");
var MuiMenuItem_1 = require("./components/MuiMenuItem");
var MuiPaginationItem_1 = require("./components/MuiPaginationItem");
var MuiPaper_1 = require("./components/MuiPaper");
var MuiPopover_1 = require("./components/MuiPopover");
var MuiRadio_1 = require("./components/MuiRadio");
var MuiSelect_1 = require("./components/MuiSelect");
var MuiSkeleton_1 = require("./components/MuiSkeleton");
var MuiSwitch_1 = require("./components/MuiSwitch");
var MuiSvgIcon_1 = require("./components/MuiSvgIcon");
var MuiTab_1 = require("./components/MuiTab");
var MuiTextField_1 = require("./components/MuiTextField");
var MuiTooltip_1 = require("./components/MuiTooltip");
var MuiTypography_1 = require("./components/MuiTypography");
var breakpoints = (0, system_1.createBreakpoints)({
    values: {
        xs: 0,
        sm: 361,
        md: 768,
        lg: 960,
        xl: 1200,
    },
});
var themeOptions = {
    typography: {
        htmlFontSize: 14,
        fontSize: 14,
        fontFamily: '"Noto Sans", sans-serif',
        fontWeightRegular: 500,
    },
    spacing: [0, 2, 4, 8, 12, 16, 24, 32],
    breakpoints: breakpoints,
    palette: {
        background: { default: colors_1.tannerWhite, paper: colors_1.tannerWhite },
        text: { primary: colors_1.tannerBlack },
        primary: {
            main: colors_1.tannerBlue['500'],
        },
        secondary: { main: colors_1.tannerGray['200'] },
        error: { main: '#D70E16' },
        white: {
            main: colors_1.tannerWhite,
        },
        black: {
            main: colors_1.tannerBlack,
        },
        blue: {
            main: colors_1.tannerBlue['500'],
        },
    },
    components: {
        MuiCssBaseline: MuiCssBaseline_1.MuiCssBaseline,
        MuiAlert: MuiAlert_1.MuiAlert,
        MuiAutocomplete: MuiAutocomplete_1.MuiAutocomplete,
        MuiAvatar: MuiAvatar_1.MuiAvatar,
        MuiBadge: MuiBadge_1.MuiBadge,
        MuiButtonBase: MuiButton_1.MuiButtonBase,
        MuiButton: MuiButton_1.MuiButton,
        MuiButtonGroup: MuiButton_1.MuiButtonGroup,
        MuiBreadcrumbs: MuiBreadcrumbs_1.MuiBreadcrumbs,
        MuiCard: MuiCard_1.MuiCard,
        MuiCardActions: MuiCard_1.MuiCardActions,
        MuiCardContent: MuiCard_1.MuiCardContent,
        MuiCheckbox: MuiCheckbox_1.MuiCheckbox,
        MuiChip: MuiChip_1.MuiChip,
        MuiDialog: MuiDialog_1.MuiDialog,
        MuiDialogActions: MuiDialog_1.MuiDialogActions,
        MuiDialogContent: MuiDialog_1.MuiDialogContent,
        MuiDialogTitle: MuiDialog_1.MuiDialogTitle,
        MuiDrawer: MuiDrawer_1.MuiDrawer,
        MuiFab: MuiFab_1.MuiFab,
        MuiFormLabel: MuiFormLabel_1.MuiFormLabel,
        MuiGrid: MuiGrid_1.MuiGrid,
        MuiIconButton: MuiIconButton_1.MuiIconButton,
        MuiInputBase: MuiInput_1.MuiInputBase,
        MuiInput: MuiInput_1.MuiInput,
        MuiFilledInput: MuiInput_1.MuiFilledInput,
        MuiInputLabel: MuiInput_1.MuiInputLabel,
        MuiLinearProgress: MuiLinearProgress_1.MuiLinearProgress,
        MuiLink: MuiLink_1.MuiLink,
        MuiList: MuiList_1.MuiList,
        MuiMenuItem: MuiMenuItem_1.MuiMenuItem,
        MuiPaginationItem: MuiPaginationItem_1.MuiPaginationItem,
        MuiPaper: MuiPaper_1.MuiPaper,
        MuiPopover: MuiPopover_1.MuiPopover,
        MuiRadio: MuiRadio_1.MuiRadio,
        MuiSelect: MuiSelect_1.MuiSelect,
        MuiSkeleton: MuiSkeleton_1.MuiSkeleton,
        MuiSwitch: MuiSwitch_1.MuiSwitch,
        MuiSvgIcon: MuiSvgIcon_1.MuiSvgIcon,
        MuiTab: MuiTab_1.MuiTab,
        MuiTabs: MuiTab_1.MuiTabs,
        MuiTextField: MuiTextField_1.MuiTextField,
        MuiTooltip: MuiTooltip_1.MuiTooltip,
        MuiTypography: MuiTypography_1.MuiTypography,
    },
};
exports.default = themeOptions;
//# sourceMappingURL=defaultTheme.js.map